////////////////////////////////////////////////////
/*

Use this script to emit and listen for changes

Usage:

---------------------

Listen example:

eventBus.listen("something", () => {
  some_variable = eventBus.get("something");
});

eventBus.listen("something_else", () => {
  some_other_variable = eventBus.get("something_else");
});

or:

eventBus.listen("something_else", () => {
  some_variable = eventBus.get("something");
  some_other_variable = eventBus.get("something_else");

  // can be sent back to where it came from
  eventBus.emit("something_new", some_variable + " : " + some_other_variable);
});

---------------------

Emit 

eventBus.emit("something", "what I want to send");
eventBus.emit("something_else", "I want to send this");


*/
///////////////////////////////////////////////////
!(function () {
  if (window.eventBus) {
    console.error("Name space eventBus is already used!")
  } else {
    var eventBus = {};
    window.eventBusMessage_dunks1980 = {};
    var eventbus_el;
    var count = 1;
    window.eventBus = {
      "make_eventbus_el": function(msg) {
        var selector = 'event-bus-' + msg.trim().replace(" ", "");
        eventbus_el = document.querySelector('#' + selector);
        if (!eventbus_el) {
          var newEl = document.createElement('input');
          newEl.setAttribute("id", selector);
          newEl.setAttribute("type", "hidden");
          document.body.prepend(newEl);
        }
      },
      //---------------------------------------------------//
      "get": function (msg) {
        //console.log(window.eventBusMessage_dunks1980);
        return window.eventBusMessage_dunks1980[msg];
      },
      //---------------------------------------------------//
      "emit": function (msg, message) {

        window.eventBusMessage_dunks1980[msg] = message;
        var selector = '#event-bus-' + msg.trim().replace(" ", "");

        if (!document.querySelector(selector)) {
          eventBus.make_eventbus_el(msg);
        }
        if (document.querySelector(selector)) {
          if (count > 9) {count = 1;}
          document.querySelector(selector).setAttribute('data-event', count);
          count++;
        }
      },
      //---------------------------------------------------//
      "listen": function (msg, func) {
        var selector = '#event-bus-' + msg.trim().replace(" ", "");
        if (!document.querySelector(selector)) {
          eventBus.make_eventbus_el(msg);
        }
        if (!document.querySelector(selector)) {
         return;
        }
        if (typeof func !== "function") {
          console.error(".listen() requires a callback function");
          return false;
        }
        var observer = new MutationObserver(function (mutations) {
          mutations.forEach(function (mutation) {
            if (mutation.type == "attributes") {
              if (typeof func === "function") {
                func();
              }
            }
          });
        });
        observer.observe(document.querySelector(selector), {
          attributes: true //configure it to listen to attribute changes
        });
        return observer;
      }
    }
    eventBus = window.eventBus;
  }
}());